var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loading
        ? _c("Loader", {
            attrs: {
              label: "Данные загружаются",
              active: _vm.loading,
              height: "300",
            },
          })
        : _c(
            "div",
            [
              _vm.positionSwitcherItems.length
                ? _c(
                    "div",
                    { staticClass: "position-switcher" },
                    [
                      _c("Switcher", {
                        staticClass: "h-switcher",
                        attrs: {
                          type: "group",
                          items: _vm.positionSwitcherItems,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function ({ item }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "position-switcher__item" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "position-switcher__label",
                                        },
                                        [_vm._v(" " + _vm._s(item.name) + " ")]
                                      ),
                                      item.hasExpired
                                        ? _c("Button", {
                                            directives: [
                                              {
                                                name: "b-popover",
                                                rawName: "v-b-popover.html",
                                                value: {
                                                  content:
                                                    "Категория содержит позиции, которые просрочены",
                                                  trigger: "hover blur",
                                                  placement: "top",
                                                },
                                                expression:
                                                  "{\n                content: 'Категория содержит позиции, которые просрочены',\n                trigger: 'hover blur',\n                placement: 'top',\n              }",
                                                modifiers: { html: true },
                                              },
                                            ],
                                            staticClass:
                                              "position-switcher__icon",
                                            attrs: {
                                              icon: "time-is-out",
                                              size: "iconic",
                                            },
                                          })
                                        : _vm._e(),
                                      item.hasUnissued
                                        ? _c("Button", {
                                            directives: [
                                              {
                                                name: "b-popover",
                                                rawName: "v-b-popover.html",
                                                value: {
                                                  content:
                                                    "Категория содержит позиции, которые не выданы",
                                                  trigger: "hover blur",
                                                  placement: "top",
                                                },
                                                expression:
                                                  "{\n                content: 'Категория содержит позиции, которые не выданы',\n                trigger: 'hover blur',\n                placement: 'top',\n              }",
                                                modifiers: { html: true },
                                              },
                                            ],
                                            staticClass:
                                              "position-switcher__icon",
                                            attrs: {
                                              icon: "need",
                                              size: "iconic",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3821194977
                        ),
                        model: {
                          value: _vm.positionSwitcherValue,
                          callback: function ($$v) {
                            _vm.positionSwitcherValue = $$v
                          },
                          expression: "positionSwitcherValue",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hasItems
                ? [
                    _vm.hasSelectedPosition
                      ? _c(
                          "div",
                          { staticClass: "desktop" },
                          [
                            _vm.selectedPosition.hasItems
                              ? _c(
                                  "ScrolledTable",
                                  { attrs: { "fix-last": true } },
                                  [
                                    _c(
                                      "table",
                                      {
                                        staticClass:
                                          "h-table inventory-items inventory-items--desktop",
                                      },
                                      [
                                        _c("thead", [
                                          _c(
                                            "tr",
                                            { staticClass: "inventory-item" },
                                            [
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "inventory-item__name",
                                                },
                                                [
                                                  _vm._v(
                                                    "Серийный номер / Наименование ТМЦ"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "inventory-item__model",
                                                },
                                                [
                                                  _vm._v(
                                                    "Модель типа / Модель ТМЦ"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "inventory-item__status",
                                                },
                                                [_vm._v("Статус")]
                                              ),
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "inventory-item__issued-at",
                                                },
                                                [_vm._v("Дата выдачи")]
                                              ),
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "inventory-item__issuer",
                                                },
                                                [_vm._v("Выдал")]
                                              ),
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "inventory-item__will-expire-at",
                                                },
                                                [_vm._v("Срок годности")]
                                              ),
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "inventory-item__responsible",
                                                },
                                                [_vm._v("Ответственный")]
                                              ),
                                              _c("th", {
                                                staticClass:
                                                  "inventory-item__actions",
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._l(
                                          _vm.selectedPosition.categories,
                                          function (category) {
                                            return [
                                              _c(
                                                "tr",
                                                {
                                                  key: `cat_${category.key}`,
                                                  staticClass:
                                                    "inventory-position h-table__row--header",
                                                  class: {
                                                    collapsed:
                                                      !category.isExpanded,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      category.isExpanded =
                                                        !category.isExpanded
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "8" } },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex align-items-center",
                                                        },
                                                        [
                                                          _c("svg-icon", {
                                                            staticClass:
                                                              "position-toggler",
                                                            attrs: {
                                                              name: "chevron-top-circled",
                                                              color: "primary",
                                                              size: 24,
                                                            },
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "inventory-position__name",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    category.name
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          category.hasExpired
                                                            ? _c("Button", {
                                                                directives: [
                                                                  {
                                                                    name: "b-popover",
                                                                    rawName:
                                                                      "v-b-popover.html",
                                                                    value: {
                                                                      id: "inventory-position-expired",
                                                                      container:
                                                                        "#app",
                                                                      trigger:
                                                                        "hover blur",
                                                                      content:
                                                                        "Категория содержит позиции, которые просрочены",
                                                                      placement:
                                                                        "top",
                                                                    },
                                                                    expression:
                                                                      "{\n                        id: 'inventory-position-expired',\n                        container: '#app',\n                        trigger: 'hover blur',\n                        content: 'Категория содержит позиции, которые просрочены',\n                        placement: 'top',\n                      }",
                                                                    modifiers: {
                                                                      html: true,
                                                                    },
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "inventory-position__icon",
                                                                attrs: {
                                                                  icon: "time-is-out",
                                                                  size: "iconic",
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          category.hasUnissued
                                                            ? _c("Button", {
                                                                directives: [
                                                                  {
                                                                    name: "b-popover",
                                                                    rawName:
                                                                      "v-b-popover.html",
                                                                    value: {
                                                                      id: "inventory-position-not-issued",
                                                                      container:
                                                                        "#app",
                                                                      trigger:
                                                                        "hover blur",
                                                                      content:
                                                                        "Категория содержит позиции, которые не выданы",
                                                                      placement:
                                                                        "top",
                                                                    },
                                                                    expression:
                                                                      "{\n                        id: 'inventory-position-not-issued',\n                        container: '#app',\n                        trigger: 'hover blur',\n                        content: 'Категория содержит позиции, которые не выданы',\n                        placement: 'top',\n                      }",
                                                                    modifiers: {
                                                                      html: true,
                                                                    },
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "inventory-position__icon",
                                                                attrs: {
                                                                  icon: "need",
                                                                  size: "iconic",
                                                                },
                                                              })
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "b-collapse",
                                                {
                                                  key: `cat_${category.key}_exp`,
                                                  attrs: { tag: "tbody" },
                                                  model: {
                                                    value: category.isExpanded,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        category,
                                                        "isExpanded",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "category.isExpanded",
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    category.entries,
                                                    function (entry) {
                                                      return _c(
                                                        "EntryRow",
                                                        {
                                                          key: `ent_${entry.key}`,
                                                          attrs: {
                                                            entry: entry,
                                                          },
                                                        },
                                                        [
                                                          _c("EntryControls", {
                                                            attrs: {
                                                              entry: entry,
                                                            },
                                                            on: {
                                                              issue:
                                                                _vm.issueItem,
                                                              withdraw:
                                                                _vm.withdrawItem,
                                                              discard:
                                                                _vm.discardItem,
                                                              transfer:
                                                                _vm.transferItem,
                                                              showInfo:
                                                                _vm.showItemInfo,
                                                              showHistory:
                                                                _vm.showItemHistory,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  _vm._l(
                                                    category.subcategories,
                                                    function (subcategory) {
                                                      return [
                                                        _c(
                                                          "tr",
                                                          {
                                                            key: `subcat_${subcategory.key}_title`,
                                                            staticClass:
                                                              "inventory-group",
                                                          },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                attrs: {
                                                                  colspan: "8",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      subcategory.name
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._l(
                                                          subcategory.entries,
                                                          function (entry) {
                                                            return _c(
                                                              "EntryRow",
                                                              {
                                                                key: `ent_sub_${entry.key}`,
                                                                attrs: {
                                                                  entry: entry,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "EntryControls",
                                                                  {
                                                                    attrs: {
                                                                      entry:
                                                                        entry,
                                                                    },
                                                                    on: {
                                                                      issue:
                                                                        _vm.issueItem,
                                                                      withdraw:
                                                                        _vm.withdrawItem,
                                                                      discard:
                                                                        _vm.discardItem,
                                                                      transfer:
                                                                        _vm.transferItem,
                                                                      showInfo:
                                                                        _vm.showItemInfo,
                                                                      showHistory:
                                                                        _vm.showItemHistory,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                      ]
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _c("div", { staticClass: "empty" }, [
                                  _vm._v(
                                    " Для этой должности не указаны типы ТМЦ "
                                  ),
                                ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.hasSelectedPosition
                      ? _c("div", { staticClass: "mobile" }, [
                          _c(
                            "div",
                            { staticClass: "inventory-items__container" },
                            _vm._l(
                              _vm.mobileSelectedPosition.categories,
                              function (category) {
                                return _c(
                                  "div",
                                  {
                                    key: `cat_${category.key}`,
                                    staticClass: "inventory-position",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName: "v-b-toggle",
                                            value:
                                              "position-collapse-m-" +
                                              category.key,
                                            expression:
                                              "'position-collapse-m-' + category.key",
                                          },
                                        ],
                                        staticClass:
                                          "inventory-position-header d-flex align-items-center",
                                      },
                                      [
                                        _c("svg-icon", {
                                          staticClass: "position-toggler",
                                          attrs: {
                                            name: "chevron-top-circled",
                                            color: "primary",
                                            size: 24,
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "inventory-position__name",
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(category.name) + " "
                                            ),
                                          ]
                                        ),
                                        category.hasExpired
                                          ? _c("Button", {
                                              directives: [
                                                {
                                                  name: "b-popover",
                                                  rawName: "v-b-popover.html",
                                                  value: {
                                                    content:
                                                      "Категория содержит позиции, которые просрочены",
                                                    trigger: "hover blur",
                                                    placement: "top",
                                                  },
                                                  expression:
                                                    "{\n                  content: 'Категория содержит позиции, которые просрочены',\n                  trigger: 'hover blur',\n                  placement: 'top',\n                }",
                                                  modifiers: { html: true },
                                                },
                                              ],
                                              staticClass:
                                                "inventory-position__icon",
                                              attrs: {
                                                icon: "time-is-out",
                                                size: "iconic",
                                              },
                                            })
                                          : _vm._e(),
                                        category.hasUnissued
                                          ? _c("Button", {
                                              directives: [
                                                {
                                                  name: "b-popover",
                                                  rawName: "v-b-popover.html",
                                                  value: {
                                                    content:
                                                      "Категория содержит позиции, которые не выданы",
                                                    trigger: "hover blur",
                                                    placement: "top",
                                                  },
                                                  expression:
                                                    "{\n                  content: 'Категория содержит позиции, которые не выданы',\n                  trigger: 'hover blur',\n                  placement: 'top',\n                }",
                                                  modifiers: { html: true },
                                                },
                                              ],
                                              staticClass:
                                                "inventory-position__icon",
                                              attrs: {
                                                icon: "need",
                                                size: "iconic",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-collapse",
                                      {
                                        staticClass:
                                          "inventory-position__table",
                                        attrs: {
                                          id:
                                            "position-collapse-m-" +
                                            category.key,
                                          tag: "div",
                                          visible: "",
                                        },
                                      },
                                      [
                                        _c("HorizontalTable", [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "h-table h-table--horizontal inventory-items inventory-items--mobile",
                                            },
                                            [
                                              _c(
                                                "tr",
                                                [
                                                  _c("th", [
                                                    _vm._v("Подкатегория ТМЦ"),
                                                  ]),
                                                  _vm._l(
                                                    category.data.subcategory,
                                                    function (
                                                      subcategory,
                                                      subcategoryIndex
                                                    ) {
                                                      return _c(
                                                        "td",
                                                        {
                                                          key: subcategoryIndex,
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                subcategory ||
                                                                  "—"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _c(
                                                "tr",
                                                [
                                                  _c("th", [
                                                    _vm._v(
                                                      "Серийный номер / Наименование ТМЦ "
                                                    ),
                                                  ]),
                                                  _vm._l(
                                                    category.data.name,
                                                    function (name, nameIndex) {
                                                      return _c(
                                                        "td",
                                                        { key: nameIndex },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              class: {
                                                                "greyed-out":
                                                                  !name.isIssued,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    name.serialNumber ||
                                                                      "—"
                                                                  ) +
                                                                  " / " +
                                                                  _vm._s(
                                                                    name.item ||
                                                                      "—"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "inventory-position__type",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    name.type
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _c(
                                                "tr",
                                                [
                                                  _c("th", [
                                                    _vm._v(
                                                      "Модель типа / Модель ТМЦ"
                                                    ),
                                                  ]),
                                                  _vm._l(
                                                    category.data.model,
                                                    function (
                                                      model,
                                                      modelIndex
                                                    ) {
                                                      return _c(
                                                        "td",
                                                        { key: modelIndex },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                model.type ||
                                                                  "—"
                                                              ) +
                                                              " / "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                "greyed-out":
                                                                  !model.isIssued,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    model.item ||
                                                                      "—"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _c(
                                                "tr",
                                                [
                                                  _c("th", [_vm._v("Статус")]),
                                                  _vm._l(
                                                    category.data.status,
                                                    function (
                                                      status,
                                                      statusIndex
                                                    ) {
                                                      return _c(
                                                        "td",
                                                        {
                                                          key: statusIndex,
                                                          class: {
                                                            "h-table__cell--warning":
                                                              !status.isIssued,
                                                            "h-table__cell--error":
                                                              status.isExpired,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                status.name ||
                                                                  "Не выдан"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _c(
                                                "tr",
                                                [
                                                  _c("th", [
                                                    _vm._v("Дата выдачи"),
                                                  ]),
                                                  _vm._l(
                                                    category.data.issuedAt,
                                                    function (
                                                      issuedAt,
                                                      issuedAtIndex
                                                    ) {
                                                      return _c(
                                                        "td",
                                                        { key: issuedAtIndex },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(issuedAt) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _c(
                                                "tr",
                                                [
                                                  _c("th", [_vm._v("Выдал")]),
                                                  _vm._l(
                                                    category.data.issuer,
                                                    function (
                                                      issuer,
                                                      issuerIndex
                                                    ) {
                                                      return _c(
                                                        "td",
                                                        { key: issuerIndex },
                                                        [
                                                          issuer
                                                            ? [
                                                                issuer.id
                                                                  ? _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href: `/index.php/?r=redesign#/personal-employee/${issuer.id}/summary`,
                                                                          target:
                                                                            "_blank",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              issuer.name
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            issuer.name
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ],
                                                              ]
                                                            : _vm._e(),
                                                        ],
                                                        2
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _c(
                                                "tr",
                                                [
                                                  _c("th", [
                                                    _vm._v("Срок годности"),
                                                  ]),
                                                  _vm._l(
                                                    category.data.willExpireAt,
                                                    function (
                                                      willExpireAt,
                                                      willExpireAtIndex
                                                    ) {
                                                      return _c(
                                                        "td",
                                                        {
                                                          key: willExpireAtIndex,
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                willExpireAt ||
                                                                  "—"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _c(
                                                "tr",
                                                [
                                                  _c("th", [
                                                    _vm._v("Ответственный"),
                                                  ]),
                                                  _vm._l(
                                                    category.data.responsible,
                                                    function (
                                                      responsible,
                                                      responsibleIndex
                                                    ) {
                                                      return _c(
                                                        "td",
                                                        {
                                                          key: responsibleIndex,
                                                        },
                                                        [
                                                          responsible
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: `?r=redesign#/personal-employee/${responsible.id}/summary`,
                                                                    target:
                                                                      "_blank",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        responsible.name
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : [_vm._v(" — ")],
                                                        ],
                                                        2
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _c(
                                                "tr",
                                                [
                                                  _c("th"),
                                                  _vm._l(
                                                    category.data.entry,
                                                    function (
                                                      entry,
                                                      entryIndex
                                                    ) {
                                                      return _c(
                                                        "td",
                                                        { key: entryIndex },
                                                        [
                                                          _c("EntryControls", {
                                                            attrs: {
                                                              entry: entry,
                                                            },
                                                            on: {
                                                              issue:
                                                                _vm.issueItem,
                                                              withdraw:
                                                                _vm.withdrawItem,
                                                              discard:
                                                                _vm.discardItem,
                                                              transfer:
                                                                _vm.transferItem,
                                                              showInfo:
                                                                _vm.showItemInfo,
                                                              showHistory:
                                                                _vm.showItemHistory,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          !_vm.positions.length
                            ? _c(
                                "div",
                                { staticClass: "inventory-items__empty" },
                                [_vm._v("Записи не найдены")]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                : _c("div", { staticClass: "empty" }, [
                    _vm._v(" Для этой должности не указаны типы ТМЦ "),
                  ]),
            ],
            2
          ),
      _c("IssueItemModal", {
        ref: "issueItemModal",
        attrs: { "worker-id": _vm.workerId },
        on: {
          submit: function ($event) {
            return _vm.$emit("change")
          },
        },
      }),
      _c("WithdrawItemModal", {
        ref: "withdrawItemModal",
        attrs: { "worker-id": _vm.workerId },
        on: {
          submit: function ($event) {
            return _vm.$emit("change")
          },
        },
      }),
      _c("DiscardItemModal", {
        ref: "discardItemModal",
        attrs: { "worker-id": _vm.workerId },
        on: {
          submit: function ($event) {
            return _vm.$emit("change")
          },
        },
      }),
      _c("TransferItemModal", {
        ref: "transferItemModal",
        attrs: { "worker-id": _vm.workerId },
        on: {
          submit: function ($event) {
            return _vm.$emit("change")
          },
        },
      }),
      _c("HistorySidesheet", { ref: "historySidesheet" }),
      _c("InfoSidesheet", { ref: "infoSidesheet" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }